import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, FileCheck } from 'lucide-react';
const items = ['Guía de efectos conductuales de los antiepilépticos más usados', 'Protocolo para distinguir epilepsia vs. efecto de la medicación', 'Herramientas de comunicación con el neurólogo', 'Guía completa de derechos del niño con epilepsia en Argentina', 'Ley de Epilepsia: qué cubre y cómo exigirlo', 'Modelo de carta documento para reclamo de medicación', 'Protocolo de solicitud de amparo paso a paso', 'Guía de tramitación del CUD', 'Cobertura de terapias: fonoaudiología, psicología, TO', 'Genérico vs. marca: cuándo reclamar y cómo', 'Checklist de derechos escolares del niño con epilepsia', 'Directorio de asociaciones y recursos legales en Argentina'];
export const MasterKitIncludes = () => {
  return <section className="py-10 sm:py-14 md:py-20 bg-brand-green text-white" data-id="element-173">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="text-center mb-8 sm:mb-10 md:mb-12" data-id="element-175">
          <div className="inline-block bg-brand-gold/20 p-3 sm:p-4 rounded-full mb-4 sm:mb-6" data-id="element-176">
            <FileCheck size={32} className="text-brand-gold" data-id="element-177" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold mb-3 sm:mb-4 text-brand-gold" data-id="element-178">
            KIT EPILEPSIA BAJO CONTROL PRO™ INCLUYE:
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-cream/90" data-id="element-179">
            50 páginas de protocolos de conducta, medicación y derechos:
          </p>
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-5 sm:p-6 md:p-8 border border-white/10" data-id="element-180">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-6" data-id="element-181">
            {items.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="flex items-start gap-3" data-id="element-182">
                <CheckCircle2 size={18} className="text-brand-gold flex-shrink-0 mt-0.5" data-id="element-183" />
                <span className="text-cream/90 text-sm sm:text-base" data-id="element-184">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};